import { Attribute } from "../../../gql/graphql";
import { Content } from "./Content";

import styles from "./Card.module.scss";

export const SwiperCardPlaceholder = ({ attribute }: { attribute: Attribute }) => (
  <div className={styles.base}>
    <Content attribute={attribute} isReversed={true} />
  </div>
);
